<div class="container">
    <h1>📸 Användarinstruktion - Fototävling</h1>

    <p>
        Välkommen till fototävlingen! Denna guide hjälper dig att komma igång med att
        registrera dig och logga in på fototävlingssidan.
    </p>

    <h2>Komma igång</h2>

    <div class="step">
        <p class="step-number">Steg 1: Öppna inbjudningslänken</p>
        <p>
            Du kommer att få en länk via e-post till fototävlingen. Klicka på länken för att
            komma till registrerings- och inloggningssidan.
        </p>
    </div>

    <div class="info-box">
        <strong>📧 Tips:</strong> Om du inte hittar e-postmeddelandet, kolla i din skräppost
        eller spam-mapp.
    </div>

    <h2>Första gången du besöker sidan</h2>

    <div class="step">
        <p class="step-number">Steg 2: Kontrollera din inbjudningsstatus</p>
        <p>När du öppnar länken ser du information om vad du är inbjuden att göra:</p>
        <ul>
            <li><strong>Röstare</strong> - Du kan rösta på andra deltagares bilder</li>
            <li><strong>Deltagare</strong> - Du kan ladda upp egna bilder i tävlingen</li>
            <li>Ibland kan du vara inbjuden som både röstare och deltagare</li>
        </ul>
    </div>

    <div class="info-box">
        <strong>📋 Viktigt att veta om flikarna:</strong>
        <ul>
            <li>
                <strong>"Inte tidigare registrerad"</strong> - Använd denna flik första
                gången du besöker sidan för att skapa ett nytt konto
            </li>
            <li>
                <strong>"Registrerad sedan tidigare"</strong> - Använd denna flik om du
                redan har skapat ett konto vid ett tidigare tillfälle
            </li>
        </ul>
    </div>

    <h3>Alternativ 1: Registrera dig manuellt</h3>

    <div class="step">
        <p class="step-number">Steg 3a: Fyll i registreringsformuläret</p>
        <p>
            Se till att du är på fliken
            <span class="highlight">"Inte tidigare registrerad"</span> (den första fliken).
        </p>
        <img src="assets/register.jpg" alt="Registreringsformulär" style="
                        width: 100%;
                        margin: 15px 0;
                        border: 1px solid #ddd;
                        border-radius: 4px;
                    " />
        <p>Fyll i följande uppgifter:</p>
        <ul>
            <li><strong>Namn:</strong> Ditt för- och efternamn</li>
            <li><strong>E-post:</strong> Din e-postadress (förmodligen redan ifylld)</li>
            <li><strong>Lösenord:</strong> Välj ett säkert lösenord</li>
            <li><strong>Upprepa lösenord:</strong> Skriv in samma lösenord igen</li>
        </ul>
    </div>

    <div class="step">
        <p class="step-number">Steg 4a: Slutför registreringen</p>
        <p>
            Klicka på den gröna knappen <strong>"Registrera dig"</strong> för att skapa ditt
            konto.
        </p>
    </div>

    <h3>Alternativ 2: Registrera dig med Facebook</h3>

    <div class="step">
        <p class="step-number">Steg 3b: Använd Facebook-inloggning</p>
        <p>
            Klicka på den blå knappen <strong>"Registrera dig med Facebook"</strong>. Ditt
            namn och e-postadress hämtas automatiskt från ditt Facebook-konto.
        </p>
    </div>

    <div class="note">
        <strong>⚠️ Obs:</strong> När du registrerar dig med Facebook behöver du inte ange
        något lösenord. Din inloggning hanteras genom Facebook.
    </div>

    <h2>Logga in (om du redan har registrerat dig)</h2>

    <div class="step">
        <p class="step-number">Steg 1: Välj inloggningsfliken</p>
        <p>
            Om du redan har registrerat dig vid ett tidigare tillfälle, se till att du är på
            fliken <span class="highlight">"Registrerad sedan tidigare"</span> (den andra
            fliken).
        </p>
        <img src="assets/login.jpg" alt="Inloggningsformulär" style="
                        width: 100%;
                        margin: 15px 0;
                        border: 1px solid #ddd;
                        border-radius: 4px;
                    " />
    </div>

    <h3>Alternativ 1: Logga in med e-post och lösenord</h3>

    <div class="step">
        <p class="step-number">Steg 2a: Ange dina uppgifter</p>
        <ul>
            <li><strong>E-post:</strong> Din registrerade e-postadress</li>
            <li><strong>Lösenord:</strong> Ditt lösenord</li>
        </ul>
        <p>Klicka sedan på den gröna knappen <strong>"Logga in"</strong>.</p>
    </div>

    <div class="step">
        <p class="step-number">Glömt lösenordet?</p>
        <p>
            Om du har glömt ditt lösenord, klicka på den blå knappen
            <strong>"Glömt lösenord"</strong>. Du får då ett e-postmeddelande med en länk
            där du kan ange ett nytt lösenord.
        </p>
        <p>
            Detta fungerar även om du registrerade dig via Facebook och aldrig skapat ett
            lösenord. Du kan alltså använda "Glömt lösenord"-funktionen för att skapa ett
            lösenord och sedan kunna logga in både med Facebook och med e-post/lösenord.
        </p>
    </div>

    <h3>Alternativ 2: Logga in med Facebook</h3>

    <div class="step">
        <p class="step-number">Steg 2b: Använd Facebook</p>
        <p>
            Klicka på den blå knappen <strong>"Logga in med Facebook"</strong>. Du loggas in
            automatiskt via ditt Facebook-konto.
        </p>
    </div>

    <div class="note">
        <strong>💡 Bra att veta:</strong> Du kan alltid logga in med Facebook, även om du
        ursprungligen registrerade dig manuellt med e-post och lösenord.
        Facebook-inloggningen fungerar för alla användare.
    </div>

    <h2>Vanliga frågor</h2>

    <div class="info-box">
        <h3>❓ Vilken information sparas om mig?</h3>
        <p>Vi sparar följande information:</p>
        <ul>
            <li>Ditt namn</li>
            <li>Din e-postadress</li>
            <li>Ditt lösenord (om du inte använder Facebook-inloggning)</li>
        </ul>
        <p>
            Om du registrerar dig via Facebook hämtas ditt namn och e-postadress automatiskt
            från Facebook.
        </p>
    </div>

    <div class="info-box">
        <h3>❓ Kan jag använda samma konto för flera tävlingar?</h3>
        <p>Ja, ditt konto fungerar för alla fototävlingar du blir inbjuden till.</p>
    </div>

    <div class="info-box">
        <h3>❓ Vad händer efter att jag loggat in?</h3>
        <p>
            Efter inloggning får du tillgång till fototävlingen där du kan rösta på bilder
            och/eller ladda upp dina egna bilder, beroende på vad du är inbjuden som.
        </p>
    </div>

    <h2>Behöver du hjälp?</h2>
    <p>
        Om du stöter på problem eller har frågor, kontakta tävlingsarrangören via den
        e-postadress som skickade inbjudningen till dig.
    </p>

    <p style="margin-top: 40px; text-align: center; color: #666; font-size: 0.9em">
        Lycka till i tävlingen! 🎉
    </p>
</div>